<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">出入库记录</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">流水号</div>
                    <div class="header-item">食材名称</div>
                    <div class="header-item">保质期</div>
                    <div class="header-item">临期时间</div>

                    <div class="header-item">操作类型</div>
                    <div class="header-item">供应商</div>
                    <div class="header-item">库存量</div>

                    <div class="header-item">食材图片</div>
                    <div class="header-item">临期日期</div>
                    <div class="header-item">仓库名称</div>
                    <div class="header-item">功能间</div>
                    <div class="header-item">操作人</div>
                    <div class="header-item">操作时间</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in recordList" :key="index">
                            <div class="body-item">{{ item.numId }}</div>
                            <div class="body-item">{{ item.productName }}</div>
                            <div class="body-item">{{ item.shelfLife }}</div>
                            <div class="body-item"> {{ item.untilExpiration }}</div>
                            <div class="body-item"> {{ item.outFreezer }}</div>
                            <div class="body-item"> {{ item.vendors }}</div>
                            <div class="body-item"> {{ item.num }}{{ item.unit }}</div>

                            <div class="body-item"> <img :src="item.base64Data" alt=""></div>
                            <div class="body-item"> {{ item.expiryDate }}</div>
                            <div class="body-item"> {{ getWarehouseNameById(item.houseId) || '未知仓库' }}</div>
                            <div class="body-item"> {{ item.room }}</div>
                            <div class="body-item"> {{ item.operator }}</div>
                            <div class="body-item"> {{ item.operationDate }}</div>
                        </div>
                        <div class="empty-tip" v-if="recordList.length === 0">
                            暂无数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>

</template>

<script>
import { getStoreOperation } from "@/api/record";
import { getHouseList, getHouseListByPid } from "@/api/terminal";

export default {
    name: 'WarehouseStockRecord',
    data() {
        return {
            imageBaseUrl: 'data:image/png;base64,',
            searchForm: {
                warehouseId: '',
                operateType: '',
                materialKeyword: '',
                timeRange: [],
                operator: ''
            },
            warehouseList: [],
            recordList: [],      // 当前页显示的记录
            allRecords: [],       // 所有符合条件的记录
            total: 0,             // 总记录数
            currentPage: 1,       // 当前页码
            pageSize: 10,         // 每页显示数量
            detailVisible: false,
            currentRecord: null,
            loading: false
        }
    },
    mounted() {
        this.loadSubWarehouseList().then(() => {
            this.getRecordList(); // 首次加载数据
        });
    },
    methods: {
        /**
         * @description 加载子仓库列表
         */
        async loadSubWarehouseList() {
            try {
                const params = { userId: localStorage.getItem('userId'), pid: null };
                const mainWarehouseRes = await getHouseList(params);
                if (mainWarehouseRes && mainWarehouseRes.code === 200) {
                    const mainWarehouses = mainWarehouseRes.data || [];
                    const subWarehouseList = [];
                    for (const mainWarehouse of mainWarehouses) {
                        const subWarehouseRes = await getHouseListByPid({
                            userId: localStorage.getItem('userId'),
                            pid: mainWarehouse.houseId
                        });
                        if (subWarehouseRes && subWarehouseRes.code === 200) {
                            const subWarehouses = subWarehouseRes.data || [];
                            const pureSubWarehouses = subWarehouses.filter(item => item.pid && item.pid !== item.houseId);
                            subWarehouseList.push(...pureSubWarehouses);
                        }
                    }
                    this.warehouseList = subWarehouseList;
                }
            } catch (error) {
                console.error('加载子仓列表失败:', error);
                this.$message.error('子仓列表加载失败，将使用默认子仓数据');
                this.warehouseList = [
                    { houseId: 101, houseName: '面食子仓-一区', pid: 1 },
                    { houseId: 102, houseName: '面食子仓-二区', pid: 1 },
                    { houseId: 201, houseName: '冷冻子仓-低温区', pid: 2 },
                    { houseId: 202, houseName: '冷冻子仓-常温区', pid: 2 },
                ];
            }
        },

        /**
         * @description 根据仓库ID获取仓库名称
         * @param {number|string} houseId
         * @returns {string}
         */
        getWarehouseNameById(houseId) {
            if (!houseId) return '';
            const warehouse = this.warehouseList.find(item =>
                item.houseId == houseId || item.houseId === String(houseId)
            );
            return warehouse ? warehouse.houseName : '';
        },

        /**
         * @description 新增：前端兜底筛选（核心修复）
         */
        filterData(rawData) {
            if (!Array.isArray(rawData)) return [];

            return rawData.filter(item => {
                // 1. 仓库筛选
                if (this.searchForm.warehouseId && item.houseId != this.searchForm.warehouseId) {
                    return false;
                }

                // 2. 操作类型筛选（in=入库=1，out=出库=非1）
                if (this.searchForm.operateType) {
                    const isIn = ['1', 1].includes(item.outFreezer);
                    if (this.searchForm.operateType === 'in' && !isIn) return false;
                    if (this.searchForm.operateType === 'out' && isIn) return false;
                }

                // 3. 食材名称/编码关键词筛选
                if (this.searchForm.materialKeyword) {
                    const keyword = this.searchForm.materialKeyword.toLowerCase().trim();
                    const productName = (item.productName || '').toLowerCase();
                    const numId = (item.numId || '').toLowerCase(); // 流水号/编码
                    if (!productName.includes(keyword) && !numId.includes(keyword)) {
                        return false;
                    }
                }

                // 4. 时间范围筛选
                if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                    const start = new Date(this.searchForm.timeRange[0]).setHours(0, 0, 0, 0);
                    const end = new Date(this.searchForm.timeRange[1]).setHours(23, 59, 59, 999);
                    const recordTime = new Date(item.operationDate).setHours(0, 0, 0, 0);
                    if (recordTime < start || recordTime > end) {
                        return false;
                    }
                }

                return true;
            });
        },

        /**
         * @description 核心方法：获取记录列表（支持筛选）
         */
        getRecordList() {
            this.loading = true;
            // 1. 修复：转换筛选参数（关键）
            const params = {
                userId: localStorage.getItem('userId'),
                warehouseId: this.searchForm.warehouseId || '',
                // 操作类型转换：in→1，out→0，空→不传
                operateType: this.searchForm.operateType === 'in' ? 1 : (this.searchForm.operateType === 'out' ? 0 : ''),
                materialKeyword: this.searchForm.materialKeyword || '',
            };

            // 2. 处理时间范围参数
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.startTime = this.searchForm.timeRange[0];
                params.endTime = this.searchForm.timeRange[1];
            }

            // 3. 调用接口
            getStoreOperation(params).then(res => {
                this.loading = false;
                if (res && res.code === 200) {
                    // 4. 修复：先前端筛选，再分页
                    const filteredData = this.filterData(res.data || []);
                    this.allRecords = filteredData;
                    this.total = this.allRecords.length;
                    this.currentPage = 1;
                    this.paginateRecords();
                } else {
                    this.$message.error(res.message || '获取数据失败');
                    this.allRecords = [];
                    this.recordList = [];
                    this.total = 0;
                }
            }).catch(error => {
                this.loading = false;
                console.error('API请求异常:', error);
                this.$message.error('网络异常，请稍后重试');
                this.allRecords = [];
                this.recordList = [];
                this.total = 0;
            });
        },

        /**
         * @description 根据当前页码和每页数量进行分页
         */
        paginateRecords() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.recordList = this.allRecords.slice(startIndex, endIndex);
        },

        /**
         * @description 重置筛选条件
         */
        resetSearch() {
            this.searchForm = {
                warehouseId: '',
                operateType: '',
                materialKeyword: '',
                timeRange: [],
                operator: ''
            };
            this.currentPage = 1;
            this.getRecordList();
        },

        /**
         * @description 每页数量改变时触发
         */
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.paginateRecords();
        },

        /**
         * @description 当前页改变时触发
         */
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateRecords();
        },

        /**
         * @description 点击表格行，显示详情弹窗
         */
        handleRowClick(row) {
            if (this.$refs.table) {
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(row, true);
            }
            this.viewDetail(row);
        },

        /**
         * @description 显示详情弹窗
         */
        viewDetail(record) {
            this.currentRecord = { ...record };
            this.detailVisible = true;
        },

        /**
         * @description 判断是否已过期
         */
        isExpired(expiryDate) {
            if (!expiryDate) return false;
            try {
                const today = new Date().setHours(0, 0, 0, 0);
                const expDate = new Date(expiryDate).setHours(0, 0, 0, 0);
                return expDate < today;
            } catch (e) {
                return false;
            }
        },

        /**
         * @description 导出记录（待实现）
         */
        exportRecords() {
            this.$message.info('导出功能已触发，正在生成Excel文件...');
            setTimeout(() => {
                this.$message.success('出入库记录导出成功，已开始下载');
            }, 1500);
        },
    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>